module.exports = __webpack_public_path__ + "img/MYST-alt.6be21c05.svg";